@let control = $control();
<unity-control-wrapper displayName="Communities" [control]="control" [description]="$description()" [showHint]="$showHint()">
  <kendo-multiselect
    textField="name"
    valueField="id"
    rounded="large"
    adaptiveMode="auto"
    [autoClose]="false"
    [data]="$orderedCommunities()"
    [valuePrimitive]="true"
    [value]="control.value"
    [disabled]="control.disabled"
    [checkboxes]="true"
    [loading]="allCommunitiesResource.isLoading()"
    [class]="{ 'hide-tag-actions': control.disabled }"
    [filterable]="true"
    [clearButton]="!control.disabled"
    [placeholder]="control && control.enabled ? 'Click here to select or start typing...' : ''"
    (filterChange)="onFilterChange($event)"
    (valueChange)="updateCommunities($event)">
    <ng-template kendoMultiSelectNoDataTemplate>
      <span>No items available.</span>
    </ng-template>
  </kendo-multiselect>
</unity-control-wrapper>
